import React, { memo, useMemo } from 'react'
import { Button, Flex } from '@chakra-ui/react'
import { JGoogleIcon } from '../../../components'
import { useTranslation } from 'react-i18next'
import { CSVLink } from 'react-csv'

interface IUploadTemplate {
    modalUploadTemplateDisclosure: any
}

const UploadTemplate: React.FC<IUploadTemplate> = (props: IUploadTemplate) => {
    const { modalUploadTemplateDisclosure } = props

    const { t } = useTranslation()

    const template = useMemo(() => [
        ['label*', 'member ID*', 'Send Alert (Member ID)*', 'Address*', 'Latitude*', 'Longitude*', 'Radius (meter)*', 'Tolerance Radius (meter)', 'Tracking Hour Start*', 'Tracking Hour End*'],
        ['Belleza Office', 'aan,dimas,indra', 'support,gatot', 'Jakarta', "contoh: -6.2212324", "contoh: 106.7791311", '150', '10', '08:00', '22:00'],
    ], [])

    return (
        <Flex 
            marginTop='24px' 
            gap='24px' 
            alignItems='center'
        >
            <CSVLink 
                data={template} 
                filename='template_lokasi_kerja.csv' 
                separator=';'
            >
                <Button variant='j-outline' leftIcon={<JGoogleIcon name='download' />}>
                    {t('pengaturan_anggota_unduh_template')}
                </Button>
            </CSVLink>
            <Button 
                variant='j-primary' 
                leftIcon={<JGoogleIcon name='file_upload' />}
                onClick={modalUploadTemplateDisclosure.onOpen}
            >
                {t('pengaturan_anggota_unggah_template')}
            </Button>
        </Flex>
    )
}

export default memo(UploadTemplate)